export default {"src":"/_next/static/media/bg-circle-right.59d2a863.svg","height":1366,"width":1090};